import React, { MouseEvent, useRef, useState } from 'react';
import { Modal } from '@check24/overlay';
import styled from 'styled-components';
import useOutsideClick from '../../common/utils/useOutsideClick';
import { CommonField } from '../../common/types';

/*
 * Types
 */
type QuestionMarkIcon = Pick<CommonField, 'infoText'> & {
    className?: string;
};

/*
 * Styling
 */
export const QuestionIcon = styled.div`
    width: 20px;
    height: 20px;
    background-image: url('/img/gray-info-icon.svg');
    background-repeat: no-repeat;
    background-size: 20px 20px;
    background-position: center;
`;

const QuestionOverlayBox = styled.div`
    color: #181818;
    img {
        width: 100%;
        height: auto;
        margin-top: 15px;
    }
`;

/*
 * Component
 */
const QuestionMarkIcon: React.FC<QuestionMarkIcon> = (props) => {
    const { className, infoText } = props;

    const [overlayIsHidden, setOverlayIsHidden] = useState<boolean>(false);
    const ref = useRef<HTMLDivElement>(null);

    useOutsideClick(ref, overlayIsHidden, () => {
        setOverlayIsHidden(true);
    });

    const toggleOverlay = (event?: MouseEvent<HTMLDivElement>) => {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }

        setOverlayIsHidden(!overlayIsHidden);

        return false;
    };

    return (
        <div className={className}>
            <Modal.Mobile hide={!overlayIsHidden} onClose={() => setOverlayIsHidden(false)}>
                <QuestionOverlayBox ref={ref}>
                    <div dangerouslySetInnerHTML={{ __html: infoText || '' }} />
                </QuestionOverlayBox>
            </Modal.Mobile>

            <QuestionIcon className={className} onClick={toggleOverlay} />
        </div>
    );
};

export default QuestionMarkIcon;
